import React from 'react';
import './Card.css'
const Card = ({name, email, id}) => {
  return (
    <div className='bg-light-blue dib br3 pa3 ma2 grow bw2 shadow-5 tc'>
      <img className='size' alt= 'robot' src= {`https://images.dog.ceo/breeds/shiba/shiba-${id+9}.jpg`} />
      <div>
        <h2>{name}</h2>
        <p>{email}</p>
      </div> 
    </div>
  )
} 

export default Card;
